export const skinConcernIcons = ["acne.svg", "dark-spots.svg", "redness.svg", "wrinkles.svg",
"oiliness.svg", "dryness.svg", "clogged-pores.svg", "dullness.svg", "dark-circles.svg", "not-sure.svg"];

export const productTypeIcons = ["cleanser.svg", "toner.svg", "moisturizer.svg", "spf.svg",
"serum.svg", "eye-cream.svg", "exfoliator.svg", "mask.svg",
"makeup-remover.svg", "treatment.svg"];

export const allergicIngredientIcons = ["no.svg", "nuts.svg", "gluten.svg", "acid.svg", "citrus.svg",
"parabens.svg", "retinol.svg", "alcohol.svg", "fragrance.svg", "others.svg"];

export const budgetArray = ["<= $30", "<= $50", "<= $75", "I'm open"];

export const productTypeUpdated = ["cleanser.svg", "toner.svg", "moisturizer.svg", "spf.svg",
"serum.svg", "eye-cream.svg", "exfoliator.svg", "mask.svg", "", "", "makeup-remover.svg", "treatment.svg", "3-Step Regimen", "5-Step Regimen", "supplement.svg"];
export const RESPONSE_STATUS = {
	OK: 200,
    CREATED: 201,
	UNAUTHORIZED: 401,
	NOT_FOUND: 404
};



// WEBPACK FOOTER //
// ./src/utils/constants.js